import {
    GENERATE_PHYSICIAN_NOTIFICATIONS,
    GENERATE_PHYSICIAN_NOTIFICATIONS_SUCCESS,
    GENERATE_PHYSICIAN_NOTIFICATIONS_FAILED,

    FETCH_PHYSICIAN_NOTIFICATIONS,
    FETCH_PHYSICIAN_NOTIFICATIONS_SUCCESS,
    FETCH_PHYSICIAN_NOTIFICATIONS_FAILED,

    UPDATE_PHYSICIAN_NOTIFICATION,
    UPDATE_PHYSICIAN_NOTIFICATION_SUCCESS,
    UPDATE_PHYSICIAN_NOTIFICATION_FAILED,

    FETCH_DEALLOCATION_NOTIFICATIONS,
    FETCH_DEALLOCATION_NOTIFICATIONS_SUCCESS,
    FETCH_DEALLOCATION_NOTIFICATIONS_FAILED,

    FETCH_PATIENT_WITH_NO_DATA,
    FETCH_PATIENT_WITH_NO_DATA_SUCCESS,
    FETCH_PATIENT_WITH_NO_DATA_FAILED,
    FETCH_PATIENT_WITH_LAST_NIGHT_DATA,
    FETCH_PATIENT_WITH_LAST_NIGHT_DATA_SUCCESS,
    FETCH_PATIENT_WITH_LAST_NIGHT_DATA_FAILED,
    FETCH_RECENT_PATIENT_DATA,
    FETCH_RECENT_PATIENT_DATA_SUCCESS,
    FETCH_RECENT_PATIENT_DATA_FAILED,
    FETCH_WIDGETS,
    FETCH_WIDGETS_SUCCESS,
    FETCH_WIDGETS_FAILED
} from "constants/ActionTypes";

const initial_state = {
    generating_physician_notifications: null,
    generating_physician_notifications_success: null,
    generating_physician_notifications_failed: null,
    generated_physician_notifications: null,

    fetching_physician_notifications: null,
    fetching_physician_notifications_success: null,
    fetching_physician_notifications_failed: null,
    fetched_physician_notifications: null,

    updating_physician_notification: null,
    updating_physician_notification_success: null,
    updating_physician_notification_failed: null,
    updated_physician_notification: null,

    fetching_deallocation_notifications: null,
    fetching_deallocation_notifications_success: null,
    fetching_deallocation_notifications_failed: null,
    fetched_deallocation_notifications: null,

    fetched_reserved_data_notifications: null,

    patients_with_no_data: null,
    patients_with_last_night_data: null,
    recent_patient_list: [],
    fetching_last_night_data: false,
    fetching_patient_with_no_data: false,
    fetching_recent_patient: false,
    error: null,
    is_error: false,
    are_devices_alloted: false,
};

const fetch_no_data_last_night_reducer = (state = initial_state, action) => {
    switch (action.type) {
        case FETCH_PATIENT_WITH_LAST_NIGHT_DATA: {
            return {
                ...state,
                fetching_last_night_data: true
            };
        }
        case FETCH_PATIENT_WITH_LAST_NIGHT_DATA_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                fetching_last_night_data: false
            };
        }
        case FETCH_PATIENT_WITH_LAST_NIGHT_DATA_FAILED: {
            return {
                ...state,
                is_error: true,
                error: action.error,
                fetching_last_night_data: false
            };
        }
        case FETCH_PATIENT_WITH_NO_DATA: {
            return {
                ...state,
                fetching_patient_with_no_data: true
            };
        }
        case FETCH_PATIENT_WITH_NO_DATA_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                fetching_patient_with_no_data: false
            };
        }
        case FETCH_PATIENT_WITH_NO_DATA_FAILED: {
            return {
                ...state,
                is_error: true,
                error: action.error,
                fetching_patient_with_no_data: false
            };
        }
        case FETCH_RECENT_PATIENT_DATA: {
            return {
                ...state,
                fetching_recent_patient: true
            };
        }
        case FETCH_RECENT_PATIENT_DATA_SUCCESS: {
            return {
                ...state,
                recent_patient_list: action.payload,
                fetching_recent_patient: false
            };
        }
        case FETCH_RECENT_PATIENT_DATA_FAILED: {
            return {
                ...state,
                is_error: true,
                error: action.error,
                fetching_recent_patient: false
            };
        }
        case FETCH_WIDGETS: {
            return {
                ...state
            }
        }
        case FETCH_WIDGETS_SUCCESS: {
            return {
                ...state,
                ...action.payload
            }
        }
        case FETCH_WIDGETS_FAILED: {
            return {
                ...state,
                error: true
            }
        }
        case GENERATE_PHYSICIAN_NOTIFICATIONS: {
            return {
                ...state,
                generating_physician_notifications: true,
                generated_physician_notifications: null,
            }
        }
        case GENERATE_PHYSICIAN_NOTIFICATIONS_SUCCESS: {
            return {
                ...state,
                generating_physician_notifications: false,
                generating_physician_notifications_success: true,
                generating_physician_notifications_failed: false,
                generated_physician_notifications: { ...action.data },
            }
        }
        case GENERATE_PHYSICIAN_NOTIFICATIONS_FAILED: {
            return {
                ...state,
                generating_physician_notifications: false,
                generating_physician_notifications_success: false,
                generating_physician_notifications_failed: true,
            }
        }
        case FETCH_PHYSICIAN_NOTIFICATIONS: {
            return {
                ...state,
                fetching_physician_notifications: true,
                fetched_physician_notifications: null,
            }
        }
        case FETCH_PHYSICIAN_NOTIFICATIONS_SUCCESS: {
            return {
                ...state,
                fetching_physician_notifications: false,
                fetching_physician_notifications_success: true,
                fetching_physician_notifications_failed: false,
                fetched_physician_notifications: [...action.data],
            }
        }
        case FETCH_PHYSICIAN_NOTIFICATIONS_FAILED: {
            return {
                ...state,
                fetching_physician_notifications: false,
                fetching_physician_notifications_success: false,
                fetching_physician_notifications_failed: true,
            }
        }
        case UPDATE_PHYSICIAN_NOTIFICATION: {
            return {
                ...state,
                updating_physician_notification: true,
                updated_physician_notification: null,
            }
        }
        case UPDATE_PHYSICIAN_NOTIFICATION_SUCCESS: {
            return {
                ...state,
                updating_physician_notification: false,
                updating_physician_notification_success: true,
                updating_physician_notification_failed: false,
                updated_physician_notification: { ...action.data },
            }
        }
        case UPDATE_PHYSICIAN_NOTIFICATION_FAILED: {
            return {
                ...state,
                updating_physician_notification: false,
                updating_physician_notification_success: false,
                updating_physician_notification_failed: true,
            }
        }
        case FETCH_DEALLOCATION_NOTIFICATIONS: {
            return {
                ...state,
                fetching_deallocation_notifications: true,
                fetched_deallocation_notifications: null,
            }
        }
        case FETCH_DEALLOCATION_NOTIFICATIONS_SUCCESS: {
            const { data, reserved_data } = action.data;
            return {
                ...state,
                fetching_deallocation_notifications: false,
                fetching_deallocation_notifications_success: true,
                fetching_deallocation_notifications_failed: false,
                fetched_deallocation_notifications: data,
                fetched_reserved_data_notifications: reserved_data
            }
        }
        case FETCH_DEALLOCATION_NOTIFICATIONS_FAILED: {
            return {
                ...state,
                fetching_deallocation_notifications: false,
                fetching_deallocation_notifications_success: false,
                fetching_deallocation_notifications_failed: true,
            }
        }
        default:
            return state;
    }
};

export default fetch_no_data_last_night_reducer;